<div fxLayout="column" fxFlexFill *ngIf="!loader">

    <div class="divider layout-padd-2" ngClass.xs="layout-padd" fxLayoutAlign="start center" fxLayoutGap="10px">

        <button mat-icon-button (click)="goBack()">
            <mat-icon>arrow_back</mat-icon>
        </button>

        <div fxLayout="column">
            <span class="mat-title">{{currMerchant.denomination | capitalize | descFilter: 20}}</span>
            <span class="mat-title boldest">{{"booking.book"|translate}}</span>
        </div>

    </div>
    <div class="layout-padd fill-rest scrolled" ngClass.xs="layout-padd-1" style="margin-bottom: 50px;">

        <div fxLayout="row wrap">

            <div *ngFor="let point of BookingPoinfofsales" class="rad-bord clicked" style="padding: 5px;" fxFlex=33
                fxFlex.md=50 fxFlex.sm=100 fxFlex.xs=100>

                <mat-card class="rad-bord pos-card" style="overflow: hidden;" (click)="selectPOS(point);"
                    angulartics2On="click" angularticsAction="clickSelect" angularticsCategory="pointsOfSale" fxFlex>

                    <div mat-card-image class="pos-img-cov"
                        [ngStyle]="point?{'background-image': 'url(' + (point.banner ? (point.banner | prodSizeFilter:'1920') :''  ) + ')'}:null"
                        [ngStyle.gt-sm]="point?{'height.px': 250, 'background-image': 'url(' + (point.banner_link ? (point.banner | prodSizeFilter:'1920') : ''  ) + ')'}:null"
                        [ngStyle.sm]="point?{'height.px': 200, 'background-image': 'url(' + (point.banner? (point.banner| prodSizeFilter:'1920') : ''  ) + ')'}:null"
                        [ngStyle.xs]="point?{'height.px': 150, 'background-image': 'url(' + (point.banner ? (point.banner | prodSizeFilter:'1920') :'' ) + ')'}:null"
                        :null>
                    </div>

                    <div>
                        <div class="pos-card-title boldest">{{point.denomination}}
                        </div>
                        <div class="pos-card-subtitle" style="padding-bottom: 8px;">{{point.address | capitalize}},
                            {{point.postal | capitalize}} {{point.city | uppercase}}
                        </div>
                        <div class="pos-card-subtitle-2">
                            <i class="fas fa-mobile-alt"></i>
                            <span *ngIf="point.mobile"> : {{point.mobile}}</span>
                            <span>&nbsp;&nbsp;</span>

                            <span *ngIf="point.phone"> <i class="fas fa-phone fa-flip-horizontal"></i> :
                                {{point.phone}}</span>
                        </div>
                    </div>



                </mat-card>

            </div>

        </div>

    </div>
</div>

<app-popup-loader [flagLoading]="loader" [size]="30"
    [statusMessage]="'loaderText.pofReser'|translate">
</app-popup-loader>